import React from 'react'

import { ContactCardsPartProps } from './contact-cards.d';

import ContactCards from '/react4xp/components/ContactCards';

function ContactCardsPart(props: ContactCardsPartProps) {
    return <ContactCards {...props} />
}

export default (props) => <ContactCardsPart {...props} /> 
